import { Module } from 'vuex';
import { EmployeePerm } from '@/api';

export interface EmployeePermsState {
  isSuperAdmin: boolean;
  perms: Array<EmployeePerm>;
}

declare const PERMS: Array<EmployeePerm>;

export default {
  namespaced: true,
  state: () => {
    return {
      isSuperAdmin: PERMS.findIndex(p => p.name === 'superadmin') >= 0,
      perms: PERMS
    };
  },
  mutations: {
    update(state: EmployeePermsState, perms: Array<EmployeePerm>) {
      state.isSuperAdmin = perms.findIndex(p => p.name === 'superadmin') >= 0;
      state.perms = perms;
    }
  },
  getters: {
    has: (state: EmployeePermsState) => (name: string, writable: boolean | undefined) => {
      const perm = state.perms.find(p => p.name === name);
      if (perm) {
        if (writable === true) {
          return perm.writable === true;
        }
        return true;
      }
      return false;
    }
  }
} as Module<EmployeePermsState, any>;
